import {Component, Input, OnInit} from '@angular/core';
import {
  WorkflowInstanceStepPostSequencingService
} from 'src/app/services/workflow-instance-step-post-sequencing.service';
import {WorkflowInstanceModel} from "../../../../models/workflow/workflow-instance.model";
import {WorkflowDetailClientService} from "../../../dialog/workflow-detail-dialog/workflow-detail-client.service";
import {
  WorkflowStepLibraryPostSequencingModel
} from "../../../../models/workflow-step/workflow-step-library-post-sequencing.model";
import {faFileImport} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'app-library-post-sequencing',
  templateUrl: './library-post-sequencing.component.html',
  styleUrls: ['./library-post-sequencing.component.scss']
})
export class LibraryPostSequencingComponent implements OnInit {
  faFileImport = faFileImport;
  private isInitializing: boolean = true;

  @Input() workflowInstance: WorkflowInstanceModel;
  @Input() workflowStep: WorkflowStepLibraryPostSequencingModel;
  @Input() readOnly: boolean = false;

  constructor(private workflowDetailClientService: WorkflowDetailClientService,
              private workflowInstanceStepPostSequencingService: WorkflowInstanceStepPostSequencingService) {
  }

  ngOnInit(): void {
    this.validateStep();
    this.isInitializing = false;
  }

  validateStep() {
    this.workflowDetailClientService.isStepValid$.next(this.workflowStep.isValid());

    // Save the current state when changes occur to prevent data loss
    if (!this.readOnly && !this.isInitializing) {
      this.workflowDetailClientService.silentSave();
    }
  }

  onUploadNewFile(files: FileList) {
    this.workflowInstanceStepPostSequencingService.manuallyAddFile(
      this.workflowStep.id,
      files).subscribe();
  }

}
